export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_ABUSE_EXPERIENCE":
      return [...state, action.payload.abuseExperience];
    case "UPDATE_ABUSE_EXPERIENCE":
      return action.payload.abuseExperience;
    case "DELETE_ABUSE_EXPERIENCE":
      return state.filter((abuseExperience) => {
        return abuseExperience.id !== action.payload.abuseExperience.id
      });
    default:
      return state;
  }
}
